var render = function render(){var _vm=this,_c=_vm._self._c;return _c('empty',{attrs:{"isSearch":_vm.isSearch,"btnText":_vm.btnText,"btnShow":_vm.btnShow},on:{"btnClick":_vm.btnClick}},[_c('p',{staticClass:"fz-16 pre yx-color-text-primary",attrs:{"slot":"desc"},slot:"desc"},[_vm._v(_vm._s(_vm.emptyText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }